const data = [
    {
        id: 0,
        image: "images/design.svg",
        heading: "Design",
        description: "End-to-end Web Ux/UI design service to make your online product more appealing to your target audience.",
    },
    {
        id: 1,
        image: "images/development.svg",
        heading: "Development",
        description: "Full-service web development to make your online presence stand out from the crowd.",
    },
    {
        id: 2,
        image: "images/launch.svg",
        heading: "Launch",
        description: "End-to-end website development, landing page service launch with performance optimization, hosting, and domain.",
    },
    {
        id: 3,
        image: "images/support.svg",
        heading: "Support",
        description: "End-to-end Web Development assistance during the project cycle's completion and launch.",
    },
];

export default data;
